export default __webpack_public_path__ + "static/media/loading-percentage.03dcbb06.svg";